<form [formGroup]="formGroup" class="no-field-space">
    <sc-flex>
        <button mat-icon-button (click)="setPreviewsDay()">
            <sc-icon iconClass="fa-chevron-left"></sc-icon>
        </button>

        <sc-content-spacer></sc-content-spacer>

        <mat-form-field appearance="fill" class="date-field">
            <mat-label>{{'registration from'| translate:['reporting.list-export.filter.from',
                translationService.language]}}</mat-label>
            <input matInput formControlName="date" [matDatepicker]="picker1" type="date-local">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <sc-content-spacer></sc-content-spacer>

        <button mat-icon-button (click)="setNextDay()">
            <sc-icon iconClass="fa-chevron-right"></sc-icon>
        </button>

        <sc-content-spacer></sc-content-spacer>

        <app-structure-node-selection class="spaceBehind"
            (selectedStructureChanged)="onSelectedStructureChanged($event)" [selectedNode]="selectedStructureNode">
        </app-structure-node-selection>

    </sc-flex>
</form>